import { RecipeFiltersType } from "@/components/Grid/Grid";
import { NextRouter } from "next/router";

const DIFFICULTY_LEVEL_QUERY_PARAM = "level";
const CATEGORIES_QUERY_PARAM = "categories";

export const getFiltersFromBrowser = (
  queryParams: NextRouter["query"],
): RecipeFiltersType => {
  const filters: RecipeFiltersType = { categories: [], difficultyLevel: null };
  if (!queryParams) return filters;

  const categoriesParam = queryParams[CATEGORIES_QUERY_PARAM];
  if (typeof categoriesParam === "string" && categoriesParam !== "") {
    filters.categories = categoriesParam.split(",").map(Number);
  }

  const difficultyLevelParam = queryParams[DIFFICULTY_LEVEL_QUERY_PARAM];
  if (typeof difficultyLevelParam === "string" && difficultyLevelParam !== "") {
    filters.difficultyLevel = Number(difficultyLevelParam);
  }

  return filters;
};

export const updateQueryParamsFromFilters = (
  filters: RecipeFiltersType,
  router: NextRouter,
) => {
  const { push, query } = router;
  const { categories, difficultyLevel } = filters;

  const newQuery: NextRouter["query"] = { ...query };
  if (categories.length > 0) {
    newQuery[CATEGORIES_QUERY_PARAM] = categories.join(",");
  } else {
    delete newQuery[CATEGORIES_QUERY_PARAM];
  }

  if (difficultyLevel != null) {
    newQuery[DIFFICULTY_LEVEL_QUERY_PARAM] = `${difficultyLevel}`;
  } else {
    delete newQuery[DIFFICULTY_LEVEL_QUERY_PARAM];
  }

  push({ query: { ...newQuery, page: 1 } }, undefined, { shallow: true });
};
